import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';

interface CreateNoteFormProps {
  onSubmit: (body: string) => void;
  isPending: boolean;
}

export function CreateNoteForm({ onSubmit, isPending }: CreateNoteFormProps) {
  const [body, setBody] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!body.trim()) return;
    onSubmit(body.trim());
    setBody('');
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <Label htmlFor="note-body">Add a note</Label>
      <textarea
        id="note-body"
        className="flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        placeholder="Write a private note about this student..."
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />
      <Button type="submit" size="sm" disabled={isPending || !body.trim()}>
        {isPending ? 'Adding...' : 'Add note'}
      </Button>
    </form>
  );
}
